<template lang="pug">
div.page
  div.loading(v-if="loading")
    loading
    p 検索中です
  div.result(v-else)
    success(v-if="existsDB" :item="item" :fromFavorite="fromFavorite")
    failure(v-else :fromFavorite="fromFavorite")
  footer-nav
</template>
<script>
import Success from "@/components/Success";
import Failure from "@/components/Failure";
import axios from "axios";
// import moji from "moji";
import Loading from "@/components/Loading";
import FooterNav from "@/components/FooterNav";

export default {
  name: "Result",
  components: {
    Success: Success,
    Failure: Failure,
    Loading: Loading,
    FooterNav: FooterNav
  },
  data() {
    return {
      // 商品オブジェクト
      item: {
        // 商品DBから必ず取ってくる情報
        jan: this.$route.params.jan,
        name: "", // 商品名
        price: "", // 値段(税込)
        composition1: "", // 組成
        composition2: "", // 組成
        color: "", // カラー
        size: "", //サイズ
        cutSale: false, // カット売りフラグ

        // 楽天APIから取得する情報
        caption: "", // 商品説明文
        imagePath: require("@/assets/img/no_image.png"), // 画像パス

        // 登録時に付随する情報
        registeredDate: "", // 登録日時
        favorited: false
      },
      existsDB: false, // 基幹DBで商品検索がヒットしたか否か
      existsRakuten: false, // 楽天APIで商品検索がヒットしたか否か
      loading: true,
      fromFavorite: this.$route.hash === "#fromFavorite"
    };
  },
  mounted() {
    Promise.resolve()
      .then(() => this.requestLambda())
      .then(() => this.requestRakutenAPI("okadayaec"))
      .then(() => this.requestRakutenAPI("okadaya1ec2"))
      .then(() => (this.loading = false));
  },
  methods: {
    requestLambda() {
      /* 基幹システムDBから商品情報を取得 */
      const url =
        "https://3yf4x9dbpe.execute-api.ap-northeast-1.amazonaws.com/master/product";
      return axios
        .get(url, { params: { jan: this.item.jan, mode: process.env.NODE_ENV } })
        .then(response => {
          if (response.status === 200) {
            this.item.name = response.data.name;
            this.item.size = response.data.size;
            this.item.price = response.data.price;
            /* 実データに組成情報がないためコメントアウト
            // 半角カナを全角カナに変換処理
            this.item.composition1 = moji(response.data.composition1)
              .convert("HK", "ZK")
              .toString();
            // 商品によって、組成2の値がない場合があるため
            if (response.data.composition2) {
              // 半角カナを全角カナに変換処理
              this.item.composition2 = moji(response.data.composition2)
                .convert("HK", "ZK")
                .toString();
            }
            */
            this.item.cutSale = response.data.cutSale;
            this.item.color = response.data.color;

            // 本番環境時GAイベントを送信
            if (process.env.NODE_ENV === "production" && this.$route.params.sendEvent) {
              this.$ga.event('search', 'sendJanTitle', this.item.jan + ':' + this.item.name, 1);
            }
            this.existsDB = true;
          }
        });
    },
    requestRakutenAPI(shopCode) {
      /* 楽天市場APIから追加の商品情報を取得 */
      if (!this.existsDB || this.existsRakuten) return;
      const url =
        "https://app.rakuten.co.jp/services/api/IchibaItem/Search/20170706";
      const params = {
        format: "json",
        keyword: this.item.jan,
        shopCode: shopCode,
        applicationId: "1040076530225300768"
      };

      return axios.get(url, { params }).then(response => {
        if (response.data.Items.length) {
          const item = response.data.Items[0].Item;
          this.item.caption = this.shapeCaption(item.itemCaption); // 商品説明文
          this.item.imagePath = item.mediumImageUrls[0].imageUrl.replace(
            "_ex=128x128",
            ""
          ); // 商品画像パス
          this.existsRakuten = true;
        }
      });
    },
    shapeCaption(caption) {
      /* 商品説明文の整形 */
      let newCaption = caption
        .replace(/[●【・※＜]/g, s => "<br>" + s)
        .replace(/[】。]/g, s => s + "<br>")
        .replace("<br>", "");
      return newCaption.indexOf("【ご注文前に必ずお読み下さい】") !== -1
        ? newCaption.substring(
            0,
            newCaption.indexOf("【ご注文前に必ずお読み下さい】")
          )
        : newCaption;
    }
  }
};
</script>
<style lang="sass" scoped>
.page
  display: flex
  flex-direction: column
  min-height: 100vh

.loading
  p
    text-align: center
  /deep/ .v-spinner
    margin-top: 20vh
</style>
